<template>
  <div
    id="import-contributors"
  >
    <form
      autocomplete="off"
      v-on:submit.prevent="submit"
      method="post"
      enctype="multipart/form-data"
      class="form"
    >
      <div
        class="contributors"
        v-if="contributors.length"
      >
        <p
          class="alert alert-success text-center"
        >
          {{ contributors.length }} Contributor{{ contributors.length > 1 ? 's' : '' }} Found<br /><br />
          Contributor portraits are not available in preview mode.
        </p>

        <ul
          class="list-group"
        >
          <li
            class="list-group-item"
            v-for="contributor in contributors"
          >
            <div
              class="d-flex bd-highlight"
            >
              <div
                class="flex-grow-1 bd-highlight"
              >
                <b>
                  {{ contributor.name }}
                </b>
                <span
                  class="badge badge-sm badge-info"
                  v-if="contributor.author"
                >
                  Author
                </span>
                <span
                  class="badge badge-sm badge-primary"
                  v-if="contributor.staff"
                >
                  Staff
                </span>
                <span
                  class="badge badge-sm badge-warning"
                  v-if="contributor.featured"
                >
                  Featured
                </span>
                <span
                  class="badge badge-sm badge-primary"
                  v-if="contributor.verified"
                >
                  Verified
                </span>
              </div>
              <div>
                <div>
                  <a
                    :href="'mailto:' + contributor.email"
                    class="ml-1"
                  >
                    <img src="../assets/shared/email.svg" />
                  </a>
                  <a
                    :href="contributor.user_detail.attributes.homepage"
                    v-if="contributor.user_detail.attributes.homepage"
                    class="ml-1"
                  >
                    <img src="../assets/shared/browser.svg" />
                  </a>
                  <a
                    :href="contributor.user_detail.attributes.social_urls.twitter_url"
                    v-if="contributor.user_detail.attributes.social_urls.twitter_url"
                    class="ml-1"
                  >
                    <img src="../assets/shared/twitter.svg" />
                  </a>
                  <a
                    :href="contributor.user_detail.attributes.social_urls.instagram_url"
                    v-if="contributor.user_detail.attributes.social_urls.instagram_url"
                    class="ml-1"
                  >
                    <img src="../assets/shared/instagram.svg" />
                  </a>
                  <a
                    :href="contributor.user_detail.attributes.social_urls.facebook_url"
                    v-if="contributor.user_detail.attributes.social_urls.facebook_url"
                    class="ml-1"
                  >
                    <img src="../assets/shared/facebook.svg" />
                  </a>
                </div>
              </div>
            </div>
            <div
              v-if="contributor.user_detail.attributes.summary"
            >
              <i>
                {{ contributor.user_detail.attributes.summary }}
              </i>
            </div>
            <p
              v-html="contributor.user_detail.attributes.bio"
            >
            </p>
            <div
              v-if="contributor.id"
            >
              <p
                class="alert alert-warning text-center"
              >
                Contributor already exists!
                <router-link :to="{
                  name: 'user',
                  params: {
                    userId: contributor.id
                  }
                }"
                  class="btn btn-sm btn-primary"
                >
                  View record
                </router-link>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div>
        <div
          class="alert alert-primary"
          v-if="!previewed"
        >
          <p
           class="text-center"
          >
            Import a zipped file of contributors. The archive should have the
            following:
          </p>

          <ul>
            <li>contributors.json</li>
            <li>portraits/</li>
            <li>portraits/parameterized-contributor-name.png</li>
          </ul>
        </div>
        <div
          class="form-group"
        >
          <div
            class="custom-file"
          >
            <input
              type="file"
              name="contributors"
              id="import_contributors"
              class="custom-file-input"
              accept="application/zip"
              required
              v-on:change="onFileChanged"
            />

            <label
              for="import_contributors"
              class="custom-file-label"
            >
              Import
              <span>
                {{ filename }}
              </span>
            </label>
          </div>
        </div>
      </div>

      <div
        class="form-group"
        v-if="filename"
      >
        <button
          type="submit"
          class="btn btn-block btn-primary"
          v-if="previewed"
        >
          Import {{ contributors.length }} Contributors
          <spinner
            size="small"
            v-if="base.loading"
          />
        </button>

        <button
          type="submit"
          class="btn btn-block btn-primary"
          v-else
        >
          Preview Import
          <spinner
            size="small"
            v-if="base.loading"
          />
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import Spinner from 'vue-simple-spinner'

export default {
  data () {
    return {
      filename: undefined,
      previewed: false
    }
  },

  computed: mapState({
    base: state => state.base,
    contributors: state => state.SettingModule.contributors,
    loaders: state => state.LoaderModule.loaders
  }),

  components: {
    'spinner': Spinner
  },

  methods: {
    onFileChanged (ev) {
      this.filename = ev.target.value
    },

    submit (ev) {
      const action = this.previewed
        ? 'importContributors' : 'previewContributors'

      const form = ev.target
      this.$store.dispatch(
        `SettingModule/${action}`,
        new FormData(form)
      ).then(resp => {
        this.previewed = action === 'previewContributors'
      }).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ImportContributors.vue